import warningIcon from "assets/images/brand/warning-error.png";
import { DSButton } from "components/UI/atoms";
import { Modal } from "components/UI/molecules";
import { useParseErrorMessage } from "./utils/useParseErrorMessage";
import "./index.scss";

export const ListingsModalFeedback = ({ brandName }) => {
  const { error, handleCloseModal } = useParseErrorMessage({ brandName });

  if (!error) return null;

  return (
    <Modal
      onBackdropClick={handleCloseModal}
      isOpen
      header={<h3>{error.title}</h3>}
      customClassName="listings-modal-feedback"
    >
      <div className="container-message">
        <div className="message">
          <img src={warningIcon} alt="warning message" />
          <p>{error.message}</p>
        </div>
        <DSButton variant="secondary" onClick={handleCloseModal}>
          {error.cta}
        </DSButton>
      </div>
    </Modal>
  );
};
